// What a user may do (same names as backend/lib/permissions.js). The server
// sends the logged-in user's permissions; the website uses them only to show
// the right menus and pages; every API checks them again on the server.
export const PERMISSIONS = {
  QUICK_ORDER: "quickOrder",
  QUEUE_ADD: "queue.add",
  QUEUE_STATUS: "queue.status",
  QUEUE_RESET: "queue.reset",
  BAKE_BOARD: "bake.board",
  BAKE_UPDATE: "bake.update",
  DELIVERY: "delivery",
  ORDER_CHECK: "order.check",
  PRODUCTS: "products",
  DASHBOARD: "dashboard",
  USERS: "users",
};

export const PERMISSION_LABELS = {
  [PERMISSIONS.QUICK_ORDER]: "Quick order, invoices, customers",
  [PERMISSIONS.QUEUE_ADD]: "Add to queue, print tokens",
  [PERMISSIONS.QUEUE_STATUS]: "Change queue status",
  [PERMISSIONS.QUEUE_RESET]: "Restart token numbers",
  [PERMISSIONS.BAKE_BOARD]: "See the bake board",
  [PERMISSIONS.BAKE_UPDATE]: "Move orders on the bake board",
  [PERMISSIONS.DELIVERY]: "Mark orders delivered",
  [PERMISSIONS.ORDER_CHECK]: "Order checker",
  [PERMISSIONS.PRODUCTS]: "Products and availability",
  [PERMISSIONS.DASHBOARD]: "Dashboard and statistics",
  [PERMISSIONS.USERS]: "Users and permissions",
};
